import React from "react";
import "./players.scss";
import LeftPlayer from "./LeftPlayer/LeftPlayer";
import TopPlayer from "./TopPlayer/TopPlayer";
import RightPlayer from "./RightPlayer/RightPlayer";
import MyHand from "./MyHand/MyHand";
function Players({ twoVstwo }) {
  return (
    <div id="players">
      <MyHand />
      <TopPlayer />
      {twoVstwo ? (
        <div>
          <LeftPlayer />
          <RightPlayer />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Players;
